import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { tiktokPixel } from './tiktok.pixel.js';
class TikTokClient {
    pixelId = 'C5ONBN5ODNNK397VL52G';
    load() {
        tiktokPixel(this.pixelId);
    }
    pageView({ id }) {
        this.load();
        window.ttq.track('ViewContent', {
            event_id: id,
        });
    }
    lead({ id, hashedEmail }) {
        this.load();
        window.ttq.identify({
            email: hashedEmail,
        });
        window.ttq.track('Subscribe', {
            event_id: id,
        });
    }
    addToCart({ id, amount, currency, plan }) {
        this.load();
        window.ttq.track('AddToCart', {
            event_id: id,
            contents: [
                {
                    content_name: plan,
                },
            ],
            value: amount,
            currency,
        });
    }
    purchase({ id, amount, currency, plan, hashedEmail }) {
        this.load();
        window.ttq.identify({
            email: hashedEmail,
        });
        for (const event of ['PlaceAnOrder', 'Purchase']) {
            window.ttq.track(event, {
                event_id: `${id}_${event}`,
                contents: [
                    {
                        content_name: plan,
                    },
                ],
                value: amount,
                currency,
            });
        }
    }
}
__decorate([
    _Memo()
], TikTokClient.prototype, "load", null);
export const tiktokClient = new TikTokClient();
